// 导入自定义图标

import HomeIcon from "@/assets/icons/home.svg";
import MiningIcon from "@/assets/icons/mining.svg";
import StakingIcon from "@/assets/icons/staking.svg";
import SwapIcon from "@/assets/icons/swap.svg";
import WhitepaperIcon from "@/assets/icons/whitepaper.svg";
// import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";

export const frontendNavData: NavProps["data"] = [
	{
		name: "",
		items: [
			{
				title: "mining.nav.home",
				path: "https://www.fomo100.io/",
				icon: <img src={HomeIcon} alt="Mining" className="w-4 h-4" />,
			},
			{
				title: "mining.nav.mining",
				path: "/mining",
				icon: <img src={MiningIcon} alt="Mining" className="w-3 h-3" />,
			},
			{
				title: "mining.nav.swap",
				path: "https://raydium.io/swap/?inputMint=Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB&outputMint=8VRWhnywFWgya1SSZaB31YBsg17sbTDrnffXxtpE3jBL",
				icon: <img src={SwapIcon} alt="Mining" className="w-3 h-3" />,
			},
			{
				title: "mining.nav.staking",
				path: "/staking",
				icon: <img src={StakingIcon} alt="Staking" className="w-3 h-3" />,
			},
			{
				title: "mining.nav.whitepaper",
				path: "https://fomo100.gitbook.io/fomo100-whitepaper/",
				icon: <img src={WhitepaperIcon} alt="Whitepaper" className="w-3 h-3" />,
			},
		],
	},
];
